const arrayToRepeat = ['#d8d8d8'];
const numberOfRepeats = 10;

const navColors = [].concat(...Array(numberOfRepeats).fill(arrayToRepeat));

export default navColors;